module.exports = __webpack_public_path__ + "img/9788963705637.022415ee.jpg";